import { FilteredLookupOptions } from '@/form/types/smarty-streets/filtered-lookup-options';
import SmartySDK from 'smartystreets-javascript-sdk';

/**
 * Create a simple lookup object
 * @param {string} address
 * @returns {Lookup}
 */
function createSimpleLookup(address: string) {
  return new SmartySDK.usAutocompletePro.Lookup(address);
}

/**
 * Create a lookup object with filters and preferences
 * @param {string} address
 * @param {FilteredLookupOptions} options
 * @returns {Lookup}
 */
function createFilteredLookup(
  address: string,
  options: FilteredLookupOptions = {
    maxResults: 8,
    preferRatio: 33,
  }
) {
  const lookup = new SmartySDK.usAutocompletePro.Lookup(address);

  if (options.maxResults !== undefined) lookup.maxResults = options.maxResults;
  if (options.includeOnlyCities) lookup.includeOnlyCities = options.includeOnlyCities;
  if (options.includeOnlyStates) lookup.includeOnlyStates = options.includeOnlyStates;
  if (options.includeOnlyZIPCodes)
    lookup.includeOnlyZIPCodes = options.includeOnlyZIPCodes;
  if (options.excludeStates) lookup.excludeStates = options.excludeStates;
  if (options.preferCities) lookup.preferCities = options.preferCities;
  if (options.preferStates) lookup.preferStates = options.preferStates;
  if (options.preferZIPCodes) lookup.preferZIPCodes = options.preferZIPCodes;
  if (options.preferRatio !== undefined) lookup.preferRatio = options.preferRatio;

  return lookup;
}

/**
 * Create a lookup object with a selected address for expanding secondaries
 * @param {string} address
 * @param {string} selected
 * @returns {Lookup}
 */
function createSelectedLookup(address: string, selected: string) {
  const lookup = new SmartySDK.usAutocompletePro.Lookup(address);
  lookup.selected = selected;
  return lookup;
}

export { createSimpleLookup, createFilteredLookup, createSelectedLookup };
